import { render, staticRenderFns } from "./GitClone.vue?vue&type=template&id=97dd79d2&"
import script from "./GitClone.vue?vue&type=script&lang=js&"
export * from "./GitClone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports